import React from "react";

export default function ContentCard(props) {
    return (
        <div className={"col border cardsContainer mx-1 p-2 mt-3 mt-md-0 " + props.className}>
            {props.children}
        </div>
    )
}